module.exports = __webpack_public_path__ + "static/bg (11)-0c8e58b1113420d515294cc0b31e7dfa.jpg";